import { ActionType, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { FETCH_REVIEWS_PHOTOS_PAGE } from '../actions/reviews-photos';
import { REVIEWS_GROUP_SET } from 'features/reviews/actions';
import { ReviewsPhotosResponse } from '../types/fetch-models';

type ReviewsPhotosPagesActions =
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.request>
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.success>
  | ActionType<typeof REVIEWS_GROUP_SET>;
const reviewsPhotosPages = createReducer<ReviewsPhotosResponse[], ReviewsPhotosPagesActions>([])
  .handleAction(FETCH_REVIEWS_PHOTOS_PAGE.request, (state, { payload }) => {
    if (payload.currentPage === 0) {
      return [];
    }
    return state;
  })
  .handleAction(FETCH_REVIEWS_PHOTOS_PAGE.success, (state, { payload }) => [...state, payload])
  .handleAction(REVIEWS_GROUP_SET, () => []);

type ReviewsPhotosLoadingActions =
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.request>
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.success>
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.failure>
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.cancel>;
const reviewsPhotosLoading = createReducer<boolean, ReviewsPhotosLoadingActions>(false)
  .handleAction(FETCH_REVIEWS_PHOTOS_PAGE.request, () => true)
  .handleAction(
    [FETCH_REVIEWS_PHOTOS_PAGE.success, FETCH_REVIEWS_PHOTOS_PAGE.failure, FETCH_REVIEWS_PHOTOS_PAGE.cancel],
    () => false,
  );

type ReviewsPhotosErrorActions =
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.request>
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.success>
  | ActionType<typeof FETCH_REVIEWS_PHOTOS_PAGE.failure>;
const reviewsPhotosError = createReducer<Error | null, ReviewsPhotosErrorActions>(null)
  .handleAction([FETCH_REVIEWS_PHOTOS_PAGE.request, FETCH_REVIEWS_PHOTOS_PAGE.success], () => null)
  .handleAction(FETCH_REVIEWS_PHOTOS_PAGE.failure, (_, { payload }) => payload);

export const reviewsPhotosRoot = combineReducers({
  reviewGallery: reviewsPhotosPages,
  loading: reviewsPhotosLoading,
  error: reviewsPhotosError,
});
